import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

Error.stackTraceLimit = 1000;

const IGNORE_ERRORS = [
  "AbortError",
  "ChunkLoadError",
  "NotSupportedError",
  "NotAllowedError",
];

const IGNORE_SUBSTRINGS = [
  "Cannot read properties of null (reading 'appendChild')",
  "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
  "Failed to load https://cdn.jsdelivr.net/npm/",
  "Loading CSS chunk",
  "Minified React error",
  "Minified Redux error",
  "Object.values is not a function",
  "Object.entries is not a function",
  "SyntaxError: Unexpected end of script",
  "Unexpected end of script",
];

const hasIgnoredClass = (errorClass: string): boolean => {
  return IGNORE_ERRORS.includes(errorClass);
};

const hasIgnoredText = (errorMessage: string): boolean => {
  for (const substring in IGNORE_SUBSTRINGS) {
    if (errorMessage.includes(substring)) {
      return true;
    }
  }

  return false;
};

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY ?? "",
  appVersion: process.env.REACT_APP_VERSION ?? "dev",
  releaseStage: process.env.REACT_APP_ENV ?? "development",
  enabledReleaseStages: ["production", "staging"],
  plugins: [new BugsnagPluginReact()],
  onError: (event) => {
    if (hasIgnoredClass(event.errors[0].errorClass)) {
      return false;
    }

    if (hasIgnoredText(event.errors[0].errorMessage)) {
      return false;
    }

    const isExternal = event.errors[0].stacktrace.find(({ file }) => {
      return !file.startsWith(`${window.location.origin}/static/js/`);
    });

    if (isExternal) {
      return false;
    }

    event.addMetadata("errors", event.errors);

    return true;
  },
});
